<!-- @format -->

<button #originRef (click)="showPopover()" [class.bg-hover]="dropdownOpen" class="button" mat-icon-button type="button">
  <ic-icon [icon]="icAnnouncement" size="24" [class.text-orange]="!viewed" [class.text-primary]="viewed"></ic-icon>
</button>
